// ¿Puede este usuario ver este módulo?
//
// La lógica vivía suelta dentro de Layout.jsx, que es quien pinta el menú. Al unificar pantallas en
// una sola con pestañas (Seguimiento), esas pestañas necesitan la MISMA respuesta: si el admin le
// había ocultado "Recalls" a recepción, esa pestaña no puede aparecer solo porque ahora viva dentro
// de otra pantalla. Con el hook, la respuesta es la misma en los dos sitios por construcción.
import { useQuery } from '@tanstack/react-query'
import api from '../services/api'
import { useAuth } from '../context/AuthContext'
import { usePermisos } from './usePermisos'
import { MODULOS, MODULO_CLAVE } from '../components/Layout'
import { decideVisibilidad } from '../services/visibilidadModulo'

export function useModuloVisible() {
  const { user } = useAuth()
  const { perms, baseRol } = usePermisos()
  const { data: rolMods } = useQuery({
    queryKey: ['rol-modulos'],
    queryFn: () => api.get('/rol-modulos').then(r => r.data).catch(() => ({ ocultos: [] })),
    staleTime: 60000,
  })
  const rolMenu = user?.base_rol || baseRol || user?.rol
  const overrideRol = {}
  ;(rolMods?.overrides || []).filter(o => o.rol === user?.rol).forEach(o => { overrideRol[o.ruta] = o.visible })

  // Por RUTA, que es como el admin guarda sus decisiones.
  //
  // LA DECISIÓN NO SE ESCRIBE AQUÍ. Estas cuatro líneas eran una COPIA de las del menú, con su mismo
  // fallo: el permiso entraba por un AND al final, así que solo podía quitar. Conceder «Almacén» a
  // una recepcionista no le abría ni el botón ni esta pestaña. Ahora el menú, esta pestaña y la
  // puerta de la ruta (PermRoute) preguntan a la misma función (services/visibilidadModulo) y no
  // pueden volver a discrepar.
  const visible = (ruta) => {
    const m = MODULOS.find(x => x.ruta === ruta)
    if (!m) return true                       // pantalla que no es un módulo: no se gobierna aquí
    if (m.soloSuperadmin && user?.es_superadmin !== true) return false
    return decideVisibilidad({
      ruta, roles: m.roles, clave: MODULO_CLAVE[ruta],
      rolUsuario: user?.rol, rolBase: rolMenu, perms, overrideRol,
    })
  }
  // ¿HA LLEGADO YA LO QUE LA CLÍNICA OCULTÓ A ESTE ROL? Mientras `rolMods` es undefined, `overrideRol`
  // va vacío y esta función contesta por la lista de roles del catálogo: o sea, que SÍ a quien la
  // clínica se lo había ocultado. Para el menú da igual (se repinta en cuanto llega), pero una pantalla
  // que con ese «sí» a medias ya pide datos y pinta un bloque enseña, en cada sesión, lo que la clínica
  // quitó. Layout ya esperaba a esto para no expulsar a nadie (`if (rolMods === undefined) return`);
  // quien lo necesite puede hacer lo mismo con `visible.listo`, sin una segunda consulta.
  visible.listo = rolMods !== undefined
  return visible
}

export default useModuloVisible
